import {
    getPolicies,
    getAllPolicies,
    deletePolicy,
    createPolicy,
    updatePolicy
} from '../../../services/PoliciesService';
import {
    CONFIRMED_GET_POLICIES
} from './PolicyTypes';

export function getPoliciesAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_POLICIES_LOADING', payload: true });
        getPolicies(currentPage, pageSize, searchTerm, filterQuery).then((response) => {
            dispatch(confirmedGetPoliciesAction(response.data.data));
        }).finally(() => {
            dispatch({ type: 'SET_POLICIES_LOADING', payload: false });
        });
    };
}

export function getAllPoliciesAction() {
    return (dispatch) => {
        getAllPolicies().then((response) => {
            dispatch(confirmedGetPoliciesAction(response.data.data));
        });
    };
}

export function confirmedGetPoliciesAction(policies) {
    return {
        type: CONFIRMED_GET_POLICIES,
        payload: policies,
    };
}

export function deletePolicyAction(policyId, history) {
    return (dispatch, getState) => {
        return deletePolicy(policyId).then((response) => {
            return response;
        });
    };
}

export function createPolicyAction(policyData) {
    return () => {
        return createPolicy(policyData).then((response) => {
            return response;
        });
    };
}

export function updatePolicyAction(policyId, policyData) {
    return () => {
        return updatePolicy(policyId, policyData).then((response) => {
            return response;
        });
    };
}

